module.exports = __webpack_public_path__ + "img/Flag_of_Estonia.ad2f46d9.svg";